export default {
  ma: "invalid_api_key",
  pa: "blacklisted",
  Ra: "no_device_identifier",
  fa: "invalid_json_response",
  la: "empty_response",
  __: "sdk_auth_error"
};
